import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/vazaoEquipamentosBicos/actions';

import MyForm from './form';

function VazaoEquipamentosBicos() {
  const redux = useSelector((state) => state.vazaoEquipamentosBicos);

  const header = useMemo(
    () => [
      {
        id: 'empe_desc',
        label: 'Empresa',
        align: 'center',
        filter: { type: 'text' },
      },
      {
        id: 'veic_cod_veic',
        label: 'Equipamento',
        align: 'center',
        filter: { type: 'number' },
      },
      { id: 'post_desc', label: 'Posto', filter: { type: 'text' } },
      { id: 'bico_cod_bico', label: 'Bico' },
      { id: 'vpbe_vazao_maxima', label: 'Vazão Máxima (L/min)' },
      { id: 'vpbe_st_reg', label: 'Ativa' },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      header={header}
      read={recordFiltering}
      remove={deleteData}
      find={findData}
      form={MyForm}
      redux={redux}
      title="Vazão Equipamentos Bicos"
      detach="rownum"
      keys={[
        'post_cod_posto',
        'bico_cod_bico',
        'empe_cod_emp',
        'veic_cod_veic',
      ]}
    />
  );
}

export default VazaoEquipamentosBicos;
